/**
 * Monta a URL de um asset (imagem/anexo) a partir do id/caminho armazenado,
 * replicando o assetUrl() do back-end. O fluxo seguro usa /api/assets.
 */
export function urlAsset(idOuCaminho: string | number | null | undefined): string {
  const raw = String(idOuCaminho ?? "").trim();
  if (!raw) return "";
  if (/^\d+$/.test(raw)) return `/api/assets/${raw}`;
  if (raw.startsWith("/api/assets/") || /^https?:\/\//i.test(raw)) {
    return raw;
  }
  return "";
}

/** Abre assets e prévias base64 em outra aba sem depender da navegação data: do navegador. */
export function abrirAssetEmNovaAba(url: string): void {
  const raw = String(url || "").trim();
  if (!raw) return;

  let destino = raw;
  let urlTemporaria = "";
  const dataUrl = raw.match(/^data:([^;,]+);base64,(.+)$/i);
  if (dataUrl) {
    const binario = atob(dataUrl[2]);
    const bytes = Uint8Array.from(binario, (caractere) => caractere.charCodeAt(0));
    urlTemporaria = URL.createObjectURL(new Blob([bytes], { type: dataUrl[1] }));
    destino = urlTemporaria;
  }

  window.open(destino, "_blank", "noopener,noreferrer");
  if (urlTemporaria) window.setTimeout(() => URL.revokeObjectURL(urlTemporaria), 60_000);
}
